import { Achieves } from 'assets/navbar/Achieves';
import { Dictionaries } from 'assets/navbar/Dictionaries';
import { Diet } from 'assets/navbar/Diet';
import { Marketing } from 'assets/navbar/Marketing';
import { Pdf } from 'assets/navbar/Pdf';
import { Photo } from 'assets/navbar/Photo';
import { Products } from 'assets/navbar/Products';
import { Sales } from 'assets/navbar/Sales';
import { Services } from 'assets/navbar/Services';
import { Settings } from 'assets/navbar/Settings';
import { Users } from 'assets/navbar/Users';
import { Videos } from 'assets/navbar/Videos';
import { NavConfig } from 'components/NavMenu/type';
import { LabelsTypes } from 'types/labels';
import { UserValues } from 'types/user';
import { PATH_DASHBOARD } from '../../../routes/paths';

export const navConfig: NavConfig[] = [
  {
    subheader: 'Продажи',
    icon: <Sales />,
    items: [
      {
        title: 'Статистика',
        roles: [UserValues.ADMIN, UserValues.MODERATOR],
        path: PATH_DASHBOARD.dashboard,
      },
      {
        title: 'Счета на оплату',
        roles: [UserValues.ADMIN, UserValues.SUPPORT, UserValues.MODERATOR],
        path: PATH_DASHBOARD.order.root,
      },
    ],
  },
  {
    subheader: 'Видео',
    icon: <Videos />,
    item: { title: 'Видео', path: PATH_DASHBOARD.video.root, roles: [UserValues.ADMIN] },
  },
  {
    subheader: 'Контент',
    icon: <Products />,
    items: [
      {
        title: 'Тренировки',
        roles: [UserValues.ADMIN],
        path: PATH_DASHBOARD.workout.root,
      },
      {
        title: 'Комплексы',
        roles: [UserValues.ADMIN],
        path: PATH_DASHBOARD.complex.root,
      },
      {
        title: 'Эфиры',
        roles: [UserValues.ADMIN],
        path: PATH_DASHBOARD.broadcast.root,
      },
      {
        title: 'Курсы',
        roles: [UserValues.ADMIN],
        path: PATH_DASHBOARD.course.root,
      },
      /** @deprecated Старая структура марафонов, будет заменена */
      {
        title: 'Марафоны (устр)',
        roles: [UserValues.ADMIN],
        path: PATH_DASHBOARD.marathon.root,
      },
      {
        title: 'Марафоны',
        roles: [UserValues.ADMIN],
        path: PATH_DASHBOARD.marathonTemplate.root,
      },
      {
        title: 'Челленджи',
        roles: [UserValues.ADMIN],
        path: PATH_DASHBOARD.challenge.root,
      },
      {
        title: 'Туториалы',
        roles: [UserValues.ADMIN],
        path: PATH_DASHBOARD.tutorial.root,
      },
      {
        title: 'Подборки',
        roles: [UserValues.ADMIN],
        path: PATH_DASHBOARD.group.root,
      },
    ],
  },
  {
    subheader: 'Питание',
    icon: <Diet />,
    items: [
      {
        title: 'Рационы питания',
        roles: [UserValues.ADMIN],
        path: PATH_DASHBOARD.diet.root,
      },
      {
        title: 'PDF пособия',
        roles: [UserValues.ADMIN],
        path: PATH_DASHBOARD.pdf.root,
      },
      {
        title: 'Подборки',
        roles: [UserValues.ADMIN],
        path: PATH_DASHBOARD.dietGroups.root,
      },
    ],
  },
  {
    subheader: 'Достижения',
    icon: <Achieves />,
    item: {
      title: 'Достижения',
      roles: [UserValues.ADMIN],
      path: PATH_DASHBOARD.achieves.root,
    },
  },
  {
    subheader: 'Фотобанк',
    icon: <Photo />,
    item: {
      title: 'Фотобанк',
      roles: [UserValues.ADMIN],
      path: PATH_DASHBOARD.photo.root,
    },
  },
  {
    subheader: 'PDF банк',
    icon: <Pdf />,
    item: {
      title: 'PDF банк',
      roles: [UserValues.ADMIN],
      path: PATH_DASHBOARD.pdfBank.root,
    },
  },
  {
    subheader: 'Пользователи',
    icon: <Users />,
    item: {
      title: 'Пользователи',
      roles: [UserValues.ADMIN, UserValues.SUPPORT, UserValues.MODERATOR, UserValues.PROMOTER],
      path: PATH_DASHBOARD.client.root,
    },
  },
  {
    subheader: 'Маркетинг',
    icon: <Marketing />,
    items: [
      // Пока скрыли за ненадобностью
      // {
      //   title: 'Промокоды',
      //   roles: [UserValues.ADMIN, UserValues.SUPPORT],
      //   path: PATH_DASHBOARD.promocode.root,
      // },
      {
        title: 'Акции / Промокоды',
        roles: [UserValues.ADMIN, UserValues.PROMOTER],
        path: PATH_DASHBOARD.promotion.root,
      },
      {
        title: 'Главная',
        roles: [UserValues.ADMIN],
        items: [
          {
            title: 'Баннеры',
            roles: [UserValues.ADMIN],
            path: PATH_DASHBOARD.banner.root,
          },
          {
            title: 'Сторис',
            roles: [UserValues.ADMIN],
            path: PATH_DASHBOARD.story.root,
          },
        ],
      },
      {
        title: 'Уведомления',
        roles: [UserValues.ADMIN],
        items: [
          {
            title: 'Отправить пуш',
            roles: [UserValues.ADMIN],
            path: PATH_DASHBOARD.sendPush.root,
          },
          {
            title: 'История нотификаций',
            roles: [UserValues.ADMIN],
            path: PATH_DASHBOARD.notification.root,
          },
          {
            title: 'Триггерные уведомления',
            roles: [UserValues.ADMIN],
            path: PATH_DASHBOARD.triggerNotifications.root,
          },
        ],
      },
      {
        title: 'Продукты',
        roles: [UserValues.ADMIN],
        path: PATH_DASHBOARD.product.root,
      },
      {
        title: 'Продукты марафонов',
        roles: [UserValues.ADMIN],
        path: PATH_DASHBOARD.marathonProduct.root,
      },
      {
        title: 'БАДы',
        roles: [UserValues.ADMIN],
        path: PATH_DASHBOARD.bad.root,
      },
      {
        title: 'Реферальная программа',
        roles: [UserValues.ADMIN],
        path: PATH_DASHBOARD.referralProgramme.root,
      },
      {
        title: 'Бонусы подписки',
        roles: [UserValues.ADMIN],
        path: PATH_DASHBOARD.label.details(LabelsTypes.subscription),
      },
      {
        title: 'Диплинки',
        roles: [UserValues.ADMIN],
        path: PATH_DASHBOARD.deepLink.root,
      },
      {
        title: 'Paywall',
        roles: [UserValues.ADMIN],
        path: PATH_DASHBOARD.paywall.root,
      },
      {
        title: 'Подарочный бокс',
        roles: [UserValues.ADMIN],
        path: PATH_DASHBOARD.giftBox.root,
      },
      {
        title: 'Акты подарков',
        roles: [UserValues.ADMIN, UserValues.MODERATOR],
        path: PATH_DASHBOARD.giftActs.root,
      },
      {
        title: 'Удержание пользователей',
        roles: [UserValues.ADMIN],
        path: PATH_DASHBOARD.userRetention.root,
      },
      {
        title: 'Керрот',
        roles: [UserValues.ADMIN],
        path: PATH_DASHBOARD.carrot.root,
      },
    ],
  },
  {
    subheader: 'Сервисы',
    icon: <Services />,
    items: [
      {
        title: 'Отзывы и комментарии',
        roles: [UserValues.ADMIN, UserValues.SUPPORT, UserValues.MODERATOR],
        path: PATH_DASHBOARD.comment.root,
      },
      {
        title: 'Аналитика',
        roles: [UserValues.ADMIN],
        items: [
          {
            title: 'История администрирования',
            roles: [UserValues.ADMIN],
            path: PATH_DASHBOARD.administrationHistory.root,
          },
          {
            title: 'Нагрузка',
            roles: [UserValues.ADMIN],
            path: PATH_DASHBOARD.analyticsLoad.root,
          },
          {
            title: 'Приложение',
            roles: [UserValues.ADMIN],
            path: PATH_DASHBOARD.analyticsApp.root,
          },
          {
            title: 'Запросы',
            roles: [UserValues.ADMIN],
            path: PATH_DASHBOARD.analyticsService.root,
          },
          {
            title: 'Usedesk',
            roles: [UserValues.ADMIN],
            path: PATH_DASHBOARD.useDesk.root,
          },
          {
            title: 'Версии',
            roles: [UserValues.ADMIN],
            path: PATH_DASHBOARD.version.root,
          },
        ],
      },
    ],
  },
  {
    subheader: 'Справочники',
    icon: <Dictionaries />,
    items: [
      {
        title: 'Словарь автомодерации',
        roles: [UserValues.ADMIN, UserValues.MODERATOR, UserValues.SUPPORT],
        path: PATH_DASHBOARD.dictionaryAutoModeration.root,
      },
      {
        title: 'Тренеры',
        roles: [UserValues.ADMIN],
        path: PATH_DASHBOARD.trainer.root,
      },
      {
        title: 'FAQ',
        roles: [UserValues.ADMIN],
        path: PATH_DASHBOARD.faq.root,
      },
      { title: 'Константы', roles: [UserValues.ADMIN], path: PATH_DASHBOARD.constant.root },
      { title: 'Социальные сети', roles: [UserValues.ADMIN], path: PATH_DASHBOARD.socials.root },
      { title: 'Страны', roles: [UserValues.ADMIN], path: PATH_DASHBOARD.country.root },
      { title: 'Уровни', roles: [UserValues.ADMIN], path: PATH_DASHBOARD.level.root },
      { title: 'Интенсивности', roles: [UserValues.ADMIN], path: PATH_DASHBOARD.intensity.root },
      { title: 'Направления', roles: [UserValues.ADMIN], path: PATH_DASHBOARD.direction.root },
      {
        title: 'Фильтры приложения',
        roles: [UserValues.ADMIN],
        path: PATH_DASHBOARD.appFilters.root,
      },
      {
        title: 'Поиск в приложении',
        roles: [UserValues.ADMIN],
        path: PATH_DASHBOARD.appSearch.root,
      },
    ],
  },
  {
    subheader: 'Настройки',
    icon: <Settings />,
    items: [
      { title: 'Сотрудники', roles: [UserValues.ADMIN], path: PATH_DASHBOARD.user.root },
      { title: 'Платёжка', roles: [UserValues.ADMIN], path: PATH_DASHBOARD.disablePayment.root },
      { title: 'Плеер', roles: [UserValues.ADMIN], path: PATH_DASHBOARD.globalPlayer.root },
      { title: 'Авторизация', roles: [UserValues.ADMIN], path: PATH_DASHBOARD.authMethods.root },
      { title: 'Фич-флаги', roles: [UserValues.ADMIN], path: PATH_DASHBOARD.featureFlag.root },
    ],
  },
];
